var map = {
	"./": 47,
	"./academy": 197,
	"./academy-dev": 198,
	"./academy-dev.js": 198,
	"./academy-local": 199,
	"./academy-local.js": 199,
	"./academy-preprod": 200,
	"./academy-preprod.js": 200,
	"./academy.js": 197,
	"./dev": 201,
	"./dev-v2": 202,
	"./dev-v2.js": 202,
	"./dev.js": 201,
	"./index": 47,
	"./index.js": 47,
	"./local": 203,
	"./local.js": 203,
	"./preprod": 204,
	"./preprod.js": 204,
	"./prod": 205,
	"./prod.js": 205
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 612;